import axios from 'axios';
import { showSuccess, showError } from './toast';

// --- Global Axios Interceptor ---
axios.interceptors.response.use(
    (response) => {
        const method = response.config.method?.toUpperCase() || 'GET';
        // Only show success toast for mutations (POST, PUT, PATCH, DELETE)
        if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
            // Check if backend returned a message
            if (response.data && response.data.message) {
                showSuccess(response.data.message);
            }
        }
        return response;
    },
    (error) => {
        // Always show error toast for failures
        if (error.response && error.response.data && error.response.data.message) {
            showError(error.response.data.message);
        } else {
            showError(error.message || 'Something went wrong with the request');
        }
        return Promise.reject(error);
    }
);

// --- Global Fetch Interceptor ---
const originalFetch = window.fetch;

window.fetch = async function () {
    let method = 'GET';
    if (arguments[1] && arguments[1].method) {
        method = arguments[1].method.toUpperCase();
    }

    try {
        const response = await originalFetch.apply(this, arguments);
        const clone = response.clone();
        
        try {
            const data = await clone.json();
            
            if (response.ok) {
                if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
                    if (data && data.message) {
                        showSuccess(data.message);
                    }
                }
            } else {
                if (data && data.message) {
                    showError(data.message);
                } else {
                    showError(`Request failed with status: ${response.status}`);
                }
            }
        } catch(e) {
            // Not a JSON response or empty body, ignore parsing errors
            if (!response.ok) {
                showError(`Request failed with status: ${response.status}`);
            }
        }
        
        return response;
    } catch (error) {
        showError(error.message || 'Network error or server is down');
        throw error;
    }
};
